import Vue from 'vue'
import { API_URL } from '../../api'
import AdministratorsFilter from '../../filters/AdministratorsFilter';
const state = {
    administratorCreate: {
        createdAdministrator: null,
        creatingAdministrator: false,
        createAdministratorStatus: null
    },
    administratorUpdate: {
        updatedAdministrator: null,
        updatingAdministrator: false,
        updateAdministratorStatus: null
    },
    administratorDelete: {
        deletingAdministrator: false,
        deleteAdministratorStatus: null
    },
    administratorSearch: {
        administratorsCount: null,
        administrators: [],
        searchingAdministrators: false,
        searchAdministratorStatus: null
    },
}
const mutations = {
    ['SET_ADMINISTRATOR_CREATE'](state, change) {
        state.administratorCreate = { ...state.administratorCreate, ...change };
    },
    ['SET_ADMINISTRATOR_UPDATE'](state, change) {
        state.administratorUpdate = { ...state.administratorUpdate, ...change };
    },
    ['SET_ADMINISTRATOR_DELETE'](state, change) {
        state.administratorDelete = { ...state.administratorDelete, ...change };
    },
    ['SET_ADMINISTRATOR_SEARCH'](state, change) {
        state.administratorSearch = { ...state.administratorSearch, ...change };
    }
}
const actions = {
    createAdministrator: ({ commit }, payload) => {
        commit('SET_ADMINISTRATOR_CREATE', { createAdministratorStatus: null, createdAdministrator: null, creatingAdministrator: true })
        return Vue.http.post(API_URL + '/administrators/create', payload).then(response => {
            commit('SET_ADMINISTRATOR_CREATE', { createAdministratorStatus: 'success', createdAdministrator: response.body.results.administrator });
        }).catch(response => {
            commit('SET_ADMINISTRATOR_CREATE', { createAdministratorStatus: 'failed' });
        }).finally(() => {
            commit('SET_ADMINISTRATOR_CREATE', { creatingAdministrator: false });
        });
    },
    updateAdministrator: ({ commit }, payload) => {
        commit('SET_ADMINISTRATOR_UPDATE', { updateAdministratorStatus: null, updatedAdministrator: null, updatingAdministrator: true })
        return Vue.http.post(API_URL + '/administrators/update/' + payload.id, payload)
            .then(response => {
                commit('SET_ADMINISTRATOR_UPDATE', { updateAdministratorStatus: 'success', updatedAdministrator: response.body.results.administrator });
            })
            .catch(response => {
                commit('SET_ADMINISTRATOR_UPDATE', { updateAdministratorStatus: 'failed' });
            })
            .finally(() => {
                commit('SET_ADMINISTRATOR_UPDATE', { updatingAdministrator: false });
            })
    },
    deleteAdministrator: ({ commit }, id) => {
        commit('SET_ADMINISTRATOR_DELETE', { deleteAdministratorStatus: null, deletedAdministrator: null, deletingAdministrator: true })
        return Vue.http.delete(API_URL + '/administrators/delete/' + id).then(response => {
            commit('SET_ADMINISTRATOR_DELETE', { deleteAdministratorStatus: 'success' });
        }).catch(response => {
            commit('SET_ADMINISTRATOR_DELETE', { deleteAdministratorStatus: 'failed' });
        }).finally(() => {
            commit('SET_ADMINISTRATOR_DELETE', { deletingAdministrator: false });
        })
    },
    searchAdministrators: ({ commit }, payload = { filter: AdministratorsFilter(), resultMode: 'default' }) => {
        commit('SET_ADMINISTRATOR_SEARCH', { searchAdministratorStatus: null, searchAdministrator: null, searchingAdministrators: true })
        let filerJson = JSON.stringify(payload.filter);
        switch (payload.resultMode) {
            case 'count': payload.resultMode = 1; break;
            case 'paginated': payload.resultMode = 2; break;
            case 'paginatedPersist': payload.resultMode = 21; break;
            default: payload.resultMode = 0; break;
        }
        var params = '?query=' + encodeURIComponent(filerJson) + '&result_mode=' + payload.resultMode;
        return Vue.http.get(API_URL + '/administrators' + params).then(response => {
            commit('SET_ADMINISTRATOR_SEARCH', { searchAdministratorStatus: 'success', administrators: response.body.results.administrators });
        }).catch(response => {
            commit('SET_ADMINISTRATOR_SEARCH', { searchAdministratorStatus: 'failed' });
        }).finally(() => {
            commit('SET_ADMINISTRATOR_SEARCH', { searchingAdministrators: false });
        })
    },
}
export default {
    state, mutations, actions
} 



// WEBPACK FOOTER //
// ./resources/js/store/modules/administratorStore.js